import {useRoute} from '@typed-router';

export function useGetInvitationCode() {
    const route = useRoute();

    function getInvitationCode(): string | undefined {
        return route.query.mfi?.toString();
    }

    return {
        getInvitationCode,
    };
}
